<template>
  <div>
    <div class="zx zx2021">
      <ul>
        <li class="li_st">
          <a href="javascript:;" @click="childMethod" rel="nofollow">
            <span class="icon_s"></span>
            <p>试听</p>
          </a>
        </li>
        <li class="li_zx">
          <a href="javascript:;" @click="childMethod" rel="nofollow">
            <span class="icon_s"></span>
            <p>咨询</p>
          </a>
        </li>
        <li class="li_bm">
          <a href="javascript:;" @click="childMethod" rel="nofollow">
            <span class="icon_s"></span>
            <p>报名</p>
          </a>
        </li>
      </ul>
      <div class="li_6" id="back" @click="backTop">
        <a href="javascript:void(0);">
          <span class="icon_s"></span>
        </a>
      </div>
    </div>
    <div class="qimo_zx" @click="childMethod" style="width: 240px;height: 56px;background: #fff;border-radius: 2px;position: fixed;right: 12px;bottom: 12px;z-index: 1000000;cursor: pointer;box-shadow: 0 0 12px rgba(0,0,0,.06);border-radius: 4px;">
      <div style="float: right; width: 58px;height: 56px;background: #0067e1 url('https://www.itcast.cn/images/indeximg3.png') no-repeat 16px 11px;border-radius: 0 4px 4px 0;"></div>
      <div style="float: right; width: 161px;height: 56px;background: url('https://www.itcast.cn/images/indeximg4.png') no-repeat 154px 24px;font-size: 15px;color: #241919;line-height: 56px;padding-left: 21px;">和我们在线交谈！</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    },
    backTop() {
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
  .zx{width: 78px; position:fixed; right:0; top:53%; margin-top:-150px; z-index: 10000;}
  .zx ul{box-shadow: 0 1px 24px rgba(39,69,193,.25);border-radius: 10px;}
  .zx li{width: 78px; height: 69px; border-bottom: 1px solid #e7e9ee; background: #fff; position: relative; z-index: 99999;}
  .zx li a{display: block;text-decoration: none; width:78px; height: 69px; color:#686868;float: left;}
  .zx li span.icon_s{ display:block; width: 25px; height: 25px; background:url(https://www.itcast.cn/images/zx/zxzxs1.png) no-repeat center top; margin: 10px auto 6px;}
  .zx li p{font-size:14px; text-align: center;}
  .zx li:hover{background: #216ef4; border-color:#216ef4;}
  .zx li:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxzxs1.png);}
  .zx li:hover p{color:#fff;}
  .zx li.li_qq span.icon_s{background-image:url(https://www.itcast.cn/images/zx/qq_icon.png);}
  .zx li.li_qq:hover{border-top-color:#e7e9ee;}
  .zx li.li_qq:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/qq_icon.png);}
  .zx li.li_1{ background: #216ef4; border-color:#216ef4;border-top-left-radius: 10px;border-top-right-radius: 10px;}
  .zx li.li_1 p{ color:#fff;}
  .zx li.li_3{ border-top-color: #e7e9ee;}
  .zx li.li_2 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/nmzx.gif);}
  .zx li.li_2:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/nmzx1.gif);}
  .zx li.li_3 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxxy.png);}
  .zx li.li_3:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxxx_2.png);}
  .zx li.li_4{border: none;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;}
  .zx li.li_4 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxbms.png);}
  .zx li.li_4:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxbms2.png);}
  .zx li.li_5 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/dhzx.gif);}
  .zx li.li_5:hover{border-color:#e7e9ee;}
  .zx li.li_5:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/dhzx1.gif);}
  .zx .li_6{width: 78px; height: 62px;background: #fff; border-radius: 10px;margin-top: 8px;box-shadow: 0 1px 17px rgba(39,69,193,.15);}
  .zx .li_6 span.icon_s{display:block; width: 25px; height: 11px;background:url(https://www.itcast.cn/images/zx/zx_bg1s.png) no-repeat center top; margin: 16px auto 8px;}
  .zx .li_6:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zx_bg1s.png);}
  .zx .li_6 a{display: block; width:78px; height: 69px; color:#686868;float: left;}
  .zx .li_6 p{font-size:14px; text-align: center;}
  .zx li.li_7 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/sqsts.png);}
  .zx li.li_7:hover span.icon_s{background-image:url(/images/zx/sqsts2.png);}
  .zx li.li_8 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/sqyhs.png);}
  .zx li.li_8:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/sqyhs2.png);}
  .zx li.li_9 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/jyxzs.png);}
  .zx li.li_9:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/jyxzs2.png);}

  .zx li.li_gd p.p_tm{width:58px; height: 22px; opacity: 0; position: absolute; left:0; top:15px;}
  .zx li.li_gd p.p_tm iframe{width:58px; height: 22px;}
  .zx li div{position: absolute; right: -1px; top:-1px; background:#216ef4;  display:none; }
  .zx li.li_gd div{background:#216ef4;}
  .zx li.li_gd div p{width:105px; padding-left: 30px; height:59px; line-height: 59px; font-weight: bold; font-size:13px; color:#fff; overflow:hidden; background: url(https://www.itcast.cn/images/zx/dhzx1.gif) no-repeat 7px center; font-family:"微软雅黑";}
  /* 右侧咨询 E */

  .zx2021{width: 70px;top: 48%;right: 12px;}
  .zx2021 ul{box-shadow: 0 0 12px rgba(0,0,0,.06);}
  .zx2021 li{width: 70px;height: 71px;border-bottom: none;}
  .zx2021 li a{width: 70px;}
  .zx2021 li span.icon_s{width: 34px;height: 24px;margin: 14px auto 0;}
  .zx2021 li p{width: 50px;height: 32px;color: #241919;line-height: 32px;margin: 0 auto;}
  .zx2021 li.li_st p,.zx2021 li.li_zx p{border-bottom: 1px #e5eeff solid;}
  .zx li.li_st{border-radius: 4px 4px 0 0;}
  .zx li.li_st span.icon_s{background-image:url(https://www.itcast.cn/images/zx/stpic1.png);}
  .zx li.li_st:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/stpic2.png);}
  .zx li.li_st:hover p{border-color: #216ef4;}

  .zx li.li_zx span.icon_s{height: 26px;margin: 11px auto 1px;background-image:url(https://www.itcast.cn/images/zx/zxpic1.png);}
  .zx li.li_zx:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/zxpic2.png);}
  .zx li.li_zx:hover p{border-color: #216ef4;}

  .zx li.li_bm{border-radius: 0 0 4px 4px;}
  .zx li.li_bm span.icon_s{background-image:url(https://www.itcast.cn/images/zx/bmpic1.png);}
  .zx li.li_bm:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/bmpic2.png);}
  .zx2021 .li_6{width: 70px;height: 25px;border-radius: 4px;box-shadow: 0 0 12px rgba(0,0,0,.06);}
  .zx2021 .li_6 a{width: 100%;height: 100%;}
  .zx2021 .li_6 span.icon_s{background-image:url(https://www.itcast.cn/images/zx/toppic.png);margin: 7px auto 0;}
  .zx2021 .li_6:hover span.icon_s{background-image:url(https://www.itcast.cn/images/zx/toppic.png);}

  /*拉幕*/

  .zx2021 .li_zxtop{
    position: absolute;
    left: 0;
    top: -83px;
    height: 75px;
    border-radius: 4px;
    box-shadow: 0 0 12px rgba(0,0,0,.06);
  }
  .zx2021 .li_zxtop span.icon_s{
    width: 53px;
    height: 43px;
    background: url("https://www.itcast.cn/images/zx/zxtop.gif") no-repeat;
    margin-top: 6px;
  }

  .zx2021 .li_zxtop p{line-height: 18px;}
  .zx2021 .li_zxtop:hover{background: #0067e1;}
  .zx2021 .li_zxtop:hover span.icon_s{background: url("https://www.itcast.cn/images/zx/zxtop2.gif") no-repeat;}
</style>
